import { useMarketConfig } from '~/app/market-config';
import { OptionsContent } from '~/app/pages/configurator/components/configurator-option/components/options-content';
import { Headline as NGCHeadline } from '~/app/pages/configurator/components/configurator-option/components/options-content/components/headline';
import { ConfiguratorOptionStyle } from '~/app/pages/configurator/components/configurator-option/styles/configurator-option-style';
import { useBreakPoint } from '~/hooks/responsive/useBreakPoint';
import { mobileBreakPoint } from '~/styles/break-points';

export function ConfiguratorOption() {
	const { config } = useMarketConfig();
	const { isCustomBreakpoint } = useBreakPoint(mobileBreakPoint);

	return (
		<ConfiguratorOptionStyle>
			{!isCustomBreakpoint && (
				<div id={'headline-container'} className="headline-container">
					<NGCHeadline hideConsumptionEmissionEngineName={config.hideConsumptionEmissionEngineName} />
				</div>
			)}
			<OptionsContent />
		</ConfiguratorOptionStyle>
	);
}
